export const saveToLocalStorage = (key: string, value: any) => {
  localStorage.setItem(key, value);
}